/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionQuotasNotifications
 */
export interface SubscriptionQuotasNotifications {
    /**
     * Maximum number of notifications to keep.
     * @type {number}
     * @memberof SubscriptionQuotasNotifications
     */
    maxCount?: number;
    /**
     * Maximum age of notifications to keep in days.
     * @type {number}
     * @memberof SubscriptionQuotasNotifications
     */
    maxAge?: number;
    /**
     * Maximum size in bytes of notifications to keep.
     * @type {number}
     * @memberof SubscriptionQuotasNotifications
     */
    maxSize?: number;
}

/**
 * Check if a given object implements the SubscriptionQuotasNotifications interface.
 */
export function instanceOfSubscriptionQuotasNotifications(value: object): value is SubscriptionQuotasNotifications {
    return true;
}

export function SubscriptionQuotasNotificationsFromJSON(json: any): SubscriptionQuotasNotifications {
    return SubscriptionQuotasNotificationsFromJSONTyped(json, false);
}

export function SubscriptionQuotasNotificationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionQuotasNotifications {
    if (json == null) {
        return json;
    }
    return {
        
        'maxCount': json['maxCount'] == null ? undefined : json['maxCount'],
        'maxAge': json['maxAge'] == null ? undefined : json['maxAge'],
        'maxSize': json['maxSize'] == null ? undefined : json['maxSize'],
    };
}

export function SubscriptionQuotasNotificationsToJSON(json: any): SubscriptionQuotasNotifications {
    return SubscriptionQuotasNotificationsToJSONTyped(json, false);
}

export function SubscriptionQuotasNotificationsToJSONTyped(value?: SubscriptionQuotasNotifications | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxCount': value['maxCount'],
        'maxAge': value['maxAge'],
        'maxSize': value['maxSize'],
    };
}

